import {
  CREATE_ISSUE_SUB_CATEGORY,
  DELETE_ISSUE_SUB_CATEGORY,
  EDIT_ISSUE_SUB_CATEGORY,
  RECEIVE_ISSUE_SUB_CATEGORIES,
  REQUEST_ALL_ISSUE_SUB_CATEGORIES,
  REQUEST_ISSUE_SUB_CATEGORY,
} from '@sophocles/entities/IssueSubCategory/issueSubCategoryActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_ISSUE_SUB_CATEGORIES: // Read
      return state.merge(action.issueSubCategories);
    case DELETE_ISSUE_SUB_CATEGORY: // Delete
      return state.delete(action.issueSubCategory.toString());
    case EDIT_ISSUE_SUB_CATEGORY: // Update
    case CREATE_ISSUE_SUB_CATEGORY: // Create
    case REQUEST_ISSUE_SUB_CATEGORY:
    case REQUEST_ALL_ISSUE_SUB_CATEGORIES:
    default:
      return state;
  }
}

export function issueSubCategoryReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_ISSUE_SUB_CATEGORY:
    case DELETE_ISSUE_SUB_CATEGORY:
    case RECEIVE_ISSUE_SUB_CATEGORIES:
    case EDIT_ISSUE_SUB_CATEGORY:
    case REQUEST_ISSUE_SUB_CATEGORY:
    case REQUEST_ALL_ISSUE_SUB_CATEGORIES:
      return getState(state, action);
    default:
      return state;
  }
}
